import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MeetingEvaluationService {

 
  NetApiUrl: string = Constants.CORE_API_BASE_URL;
  constructor(private http: HttpClient) { }

  addMeetingEvaluation(meeting: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'addMeetingEvaluationAction', meeting);
    return this.http.post<any[]>(this.NetApiUrl + 'MeetingEvaluationActionMaster/AddMeetingEvaluationAction', meeting);

    
  }
  addEvaluationResult(meeting: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'addMeetingEvaluationResult', meeting);
    return this.http.post<any[]>(this.NetApiUrl + ' MeetingEvaluationActionMaster/AddMeetingEvaluationResult', meeting);
   
  }
  getAllMeetingEvaluationActions(data: any): Observable<any> {
    return this.http.post<any>(this.NetApiUrl + 'MeetingEvaluationActionMaster/GetMeetingEvaluationActionMaster', data);
  }

}
